export const attachmentPolicyHyperLinkText = "kbc";
export const attachmentPolicyInformationReadOnly = "lbc";
export default {attachmentPolicyHyperLinkText,attachmentPolicyInformationReadOnly};